<template>
  <svg :class="rotate" width="9" height="12" viewBox="0 0 9 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 0.75L0.125 5.125L0.741875 5.74187L4.0625 2.42562L4.0625 11.25H4.9375L4.9375 2.42562L8.25813 5.74187L8.875 5.125L4.5 0.75Z" />
  </svg>
</template>

<script>
export default {
  name: "ArrowIcon",
  props: {
    rotate: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
svg{
  fill:inherit
}
.up{
transform: rotate(180deg);
}
.down{
  transform: rotate(0deg);
}
.left{
  transform: rotate(90deg)
}
.right{
  transform: rotate(270deg)
}
</style>